import { Inject, Injectable } from '@angular/core';
import { ActionsServiceInterface } from './actions-service.interface';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { DataResponse } from './responses/data.response';
import { ActionConfigInterface } from './interfaces/action-config.interface';
import { ValidationResponse } from './responses/validation.response';
import { IEnvironment } from '../environment/environment.interface';
import { map, catchError, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ActionsService implements ActionsServiceInterface {
  private endpointApi: string;

  constructor(@Inject('IEnvironmentService') private envService: IEnvironment, private http: HttpClient) {
    this.endpointApi = this.envService.getVar('services.api') as string;
  }

  public data(actionConfig: ActionConfigInterface, id: number, repository: any): Observable<DataResponse> {
    const requestParams = {
      id: undefined,
      action: actionConfig.getKey(),
      arguments: {},
      repository: actionConfig.getData(),
    };

    if (id !== null) {
      requestParams.id = id;
    }

    if (repository && Object.values(repository).length) {
      requestParams.arguments = Object.assign(requestParams.arguments, repository);
    }

    return this.http.post(`${this.endpointApi}/action/data`, requestParams).pipe(
      map((response: any) => {
        return new DataResponse(response.data);
      }),
      share(),
      catchError(() => {
        // this.logger.error('Error while getting action data: ', err);
        return of(new DataResponse());
      })
    );
  }

  public process(actionConfig: ActionConfigInterface, data: any, id: any, repository: any): Observable<DataResponse> {
    const requestParams: any = {
      action: actionConfig.getKey(),
      repository: actionConfig.getData(),
      arguments: {
        ...repository,
        ...data,
      },
    };

    if (id !== null) {
      requestParams.id = id;
    }

    return this.http.post(`${this.endpointApi}/action/process`, requestParams).pipe(
      map((res: any) => {
        return new DataResponse(res.data);
      }),
      share(),
      catchError((err) => {
        if (err.error.validation_errors) {
          return throwError(new ValidationResponse(err.error.validation_errors));
        } else {
          // this.logger.error('Error while processing action data: ', err);
          return throwError({
            message: err.error.message,
          });
        }
      })
    );
  }
}
